import { render, staticRenderFns } from "./ArticleSectionCreate.vue?vue&type=template&id=6e7497a9&scoped=true&"
import script from "./ArticleSectionCreate.vue?vue&type=script&lang=js&"
export * from "./ArticleSectionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7497a9",
  null
  
)

export default component.exports